import type { DocEntityAssociationBaseHandle } from "building-types/associations/associationHandleTypes";
import { docSourceEntityTypeToAssociationTables } from "building-types/associations/associationTables";
import type {
  DocAssociationSourceEntityType,
  DocEntityAssociation,
  DocAssociationSourceTypeToTargetType,
} from "building-types/associations/associationTypes";
import type { Doc } from "building-types/doc";

export function docGetEntityAssociation<
  S extends DocAssociationSourceEntityType,
  T extends DocAssociationSourceTypeToTargetType[S],
>(doc: Doc, handle: DocEntityAssociationBaseHandle<S, T>): DocEntityAssociation | null {
  const { id, sourceEntityType, targetEntityType } = handle;

  const tableName = docSourceEntityTypeToAssociationTables[sourceEntityType][targetEntityType];
  if (!tableName) {
    console.warn(`Could not find association table for ${sourceEntityType} and ${targetEntityType}`);
    return null;
  }

  const table = doc[tableName];
  if (!table) {
    console.warn(`Could not find association table for ${sourceEntityType} and ${targetEntityType}`);
    return null;
  }

  return table[id];
}
